/**
 * Autore: Salvo de Luca
 * Azienda Dialogicom s.r.l.s.
 * File: src/pages/AdminProfileSimple.tsx
 * Release: v2.0.0 - Componente admin ULTRA-semplificato
 */

import React from 'react';
import { appToast } from '../lib/appDialog';

const AdminProfileSimple: React.FC = () => {
  const handleComplete = () => {
    // URL params
    const urlParams = new URLSearchParams(window.location.search);
    const targetUserId = urlParams.get('userId');
    
    if (!targetUserId) {
      appToast.error('❌ User ID non trovato nell\'URL');
      return;
    }

    // Token da localStorage (vanilla JS)
    const token = localStorage.getItem('accessToken');
    
    if (!token) {
      appToast.error('❌ Token di autenticazione non trovato. Effettua nuovamente il login.');
      return;
    }

    // Dati profilo
    const profileData = {
      customer_type: 'company',
      email: 'admin.simple@example.com',
      phone_country_code: '+39',
      phone_number: '1234567890',
      phone_whatsapp: true,
      phone_telegram: false,
      company_name: 'Azienda Admin Simple',
      vat_number: '12345678901',
      unique_code: 'SIMPLE123',
      pec: 'admin@pec.example.com',
      country_prefix: 'IT'
    };

    // Chiamata API vanilla (senza async/await per evitare problemi)
    fetch(`/api/admin/profiles/${targetUserId}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(profileData)
    })
    .then(response => {
      if (response.ok) {
        appToast.success('✅ Profilo completato con successo dall\'amministratore!');
        window.close();
      } else {
        return response.json().then(errorData => {
          appToast.error('❌ Errore: ' + (errorData.error || 'Errore sconosciuto'));
        });
      }
    })
    .catch(err => {
      appToast.error('❌ Errore di connessione: ' + err.message);
      console.error('Errore:', err);
    });
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#0f172a',
      color: 'white',
      padding: '20px',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        maxWidth: '600px',
        margin: '0 auto',
        backgroundColor: '#1e293b',
        padding: '30px',
        borderRadius: '10px'
      }}>
        <h1 style={{ color: '#a855f7', marginBottom: '20px' }}>
          👨‍💼 Admin - Compilazione Profilo (Simple)
        </h1>
        
        <div style={{
          backgroundColor: '#7c3aed',
          padding: '15px',
          borderRadius: '8px',
          marginBottom: '30px'
        }}>
          <p style={{ margin: 0, fontSize: '14px' }}>
            ⚡ Componente ultra-semplificato per bypassare problemi React Hook.
            Usa solo vanilla JavaScript per la chiamata API.
          </p>
        </div>

        <div style={{ textAlign: 'center' }}>
          <p style={{ marginBottom: '30px', fontSize: '16px' }}>
            Clicca il pulsante per completare il profilo dell'utente.
            Il componente userà la chiamata API diretta testata con successo.
          </p>
          
          <button
            onClick={handleComplete}
            style={{
              backgroundColor: '#16a34a',
              color: 'white',
              border: 'none',
              padding: '15px 30px',
              fontSize: '18px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
            onMouseOver={(e) => (e.target as HTMLButtonElement).style.backgroundColor = '#15803d'}
            onMouseOut={(e) => (e.target as HTMLButtonElement).style.backgroundColor = '#16a34a'}
          >
            ✅ Completa Profilo (Simple API)
          </button>
        </div>

        <div style={{
          backgroundColor: '#374151',
          padding: '15px',
          borderRadius: '8px',
          marginTop: '30px',
          fontSize: '14px'
        }}>
          <h4 style={{ margin: '0 0 10px 0' }}>Debug Info:</h4>
          <p style={{ margin: '5px 0' }}>
            <strong>URL:</strong> {window.location.href}
          </p>
          <p style={{ margin: '5px 0' }}>
            <strong>User ID:</strong> {new URLSearchParams(window.location.search).get('userId') || 'N/A'}
          </p>
          <p style={{ margin: '5px 0' }}>
            <strong>Token:</strong> {localStorage.getItem('accessToken') ? '✅ Presente' : '❌ Mancante'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminProfileSimple;
